import { render, staticRenderFns } from "./CompanyContactPerson.vue?vue&type=template&id=088353b6"
import script from "./CompanyContactPerson.vue?vue&type=script&lang=js"
export * from "./CompanyContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports